import { Space } from "antd";
import styled from "styled-components";
import { Tooltip } from "@renderbus/ui";
// import RightArrow from "@/assets/icons/actions/right-arrow";

export interface ProfileLineProps {
  title?: string;
  titleEle?: JSX.Element | (() => JSX.Element);
  info?: string;
  action?: string | (JSX.Element | string)[];
  onClick?: (() => void) | (() => void)[];
  showArrow?: boolean;
  actionClass?: string;
  extra?: JSX.Element | string;
  noneTip?: string;
  isDingTalk?: boolean;
  disable?: boolean;
  disableTip?: string;
  className?: string;
}

export function ProfileLine({
  title,
  titleEle,
  info,
  action,
  onClick,
  actionClass,
  showArrow = true,
  extra,
  noneTip = "",
  isDingTalk = false,
  disable = false,
  disableTip = "",
  className,
}: ProfileLineProps) {
  const _onClick =
    onClick && onClick.length > 1 ? (onClick as (() => void)[]) : [onClick];
  const _action = action
    ? typeof action === "string"
      ? [action]
      : action
    : [""];
  return (
    <ProfileInfoLine className={className}>
      <ProfileInfoBox>
        <ProfileTitle>
          {typeof titleEle === "function" ? titleEle() : titleEle || title}
        </ProfileTitle>
        <ProfileInfo className={!info && !extra ? "none" : ""}>
          <span
            style={{
              marginRight: info && "10px",
              color: info ? "" : "#717475",
            }}
          >
            {info}
          </span>
          <ExtraWrapper>{extra}</ExtraWrapper>
          {!info && !extra && noneTip}
        </ProfileInfo>
      </ProfileInfoBox>
      {!isDingTalk && (
        <Space size={20}>
          <Tooltip
            trigger={disable}
            title={disableTip}
            color="rgba(0, 0, 0, 0.80)"
            overlayInnerStyle={{
              color: "#D9E6E7",
              fontSize: "12px",
            }}
          >
            <ProfileAction
              onClick={_onClick[0] as () => void}
              className={actionClass}
              disable={disable}
            >
              {_action[0]}
              {/* {showArrow && <RightArrow />} */}
            </ProfileAction>
          </Tooltip>
          {_action[1] && _onClick[1] && (
            <ProfileAction
              onClick={_onClick[1] as () => void}
              className={`${actionClass} second-action`}
            >
              {_action[1]}
            </ProfileAction>
          )}
        </Space>
      )}
    </ProfileInfoLine>
  );
}

const ExtraWrapper = styled.div`
  display: flex;
`;

const ProfileInfoBox = styled.div`
  position: relative;
  padding-left: 142px;
  display: flex;
  align-items: center;
`;

const ProfileInfoLine = styled.div`
  display: flex;
  justify-content: space-between;
  height: 46px;
  white-space: pre-line;
  &.mini-program-box {
    background-color: #1f2125;
    padding: 0 16px;
    ${ProfileInfoBox} {
      padding-left: 0;
    }
  }
`;

const ProfileTitle = styled.div`
  position: absolute;
  left: 0;
  color: #bfc2c4;
`;
const ProfileInfo = styled.div`
  display: flex;
  &.none {
    color: #757879;
  }
`;

const ProfileAction = styled.div<{
  disable?: boolean;
}>`
  display: flex;
  align-items: center;
  color: ${(p) => (p.disable ? "#747578" : "var(--main-color)")};
  cursor: pointer;
  line-height: 22px;
  height: 22px;
  position: relative;
  &.second-action::before {
    content: "|";
    position: absolute;
    width: 1px;
    left: -10px;
    color: #404146;
  }
  &:hover {
    color: ${(p) => (p.disable ? "#747578" : "var(--main-color-btn-hover)")};
  }
`;
